export const useEnableFontScaling = (allowFontScaling) => {
  return false;
};
